module.exports = __webpack_public_path__ + "static/img/TP.8b3bdcb3.png";